<template>
  <el-dialog :visible.sync="visible" :title="title" width="900px">
    <div class="view-detail">
      <div class="detail-item" :class="{ 'full-width': item.type === 'fullWidth' }" v-for="item in items" :key="item.prop">
        <div class="label">{{ item.label }}：</div>
        <div class="value">{{ info[item.prop] }}</div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "view-detail",
  props: {
    items: Array,
    title: { type: String, default: "查看详情" },
  },
  data() {
    return {
      visible: false,
      info: {},
    };
  },
  methods: {
    show(info) {
      this.info = info;
      this.visible = true;
    },
  },
};
</script>
